export default __webpack_public_path__ + "static/icon_onedodo-497aa40e6cd1e69060b9d0595ba6c1b8.svg";